import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-gis",
  "use": "icon-nav-gis-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-nav-gis\"><path d=\"M12 21s7-4.5 7-11a7 7 0 10-14 0c0 6.5 7 11 7 11z\" /><circle cx=\"12\" cy=\"10\" r=\"2.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/nav/nav-gis.svg
// module id = 1c/9
// module chunks = 24